import React from 'react'
import PropTypes from 'prop-types'

import { Button, Text } from '@/components/common'

const getMessageId = id => `pages.signUp.form.existingUser.${id}`

const ExistingUser = ({
  user,
  handleRedirectToApp,
}) => (
  <>
    <Text.P
      center
      ellipsized
      messageProps={{
        id: getMessageId('greeting'),
        values: {
          firstName: user.firstName,
          lastName: user.lastName,
        },
      }}
      noMargin
      size="large"
    />
    <Text.P center messageId={getMessageId('welcomeBack')} noMargin size="small" />
    <Text.P center messageId={getMessageId('existingUserRedirect')} noMargin size="small" />
    <div className="text-center">
      <Button
        messageId={getMessageId('redirectToNeat')}
        onClick={handleRedirectToApp}
        size="xsmall"
        variant="link"
      />
    </div>
  </>
)

ExistingUser.propTypes = {
  user: PropTypes.shape({ firstName: PropTypes.string, lastName: PropTypes.string }),
  handleRedirectToApp: PropTypes.func,
}

export default ExistingUser
